import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotFound, RouteWithSubRoutes, ErrorBoundary } from '@cordata/buffet';

const IdentityMatches = ({ routes }) => {
  const { path } = useRouteMatch();

  useEffect(
    () =>
      () => localStorage.removeItem('match-filter')
    , [],
  );

  return (
    <ErrorBoundary>
      <Switch>
        {routes.map(r => (
          <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
        ))}

        <Route path="*"><NotFound isRoute /></Route>
      </Switch>
    </ErrorBoundary>
  );
};

IdentityMatches.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
  })).isRequired,
};

export default IdentityMatches;
